import { cr } from "fire-wind-water";
import Select from "ant-design-vue/lib/select"; // 加载 JS
import "ant-design-vue/lib/select/style/css"; // 加载 CSS
import Cascader from "ant-design-vue/lib/cascader"; // 加载 JS
import "ant-design-vue/lib/cascader/style/css"; // 加载 CSS
import Icon from "ant-design-vue/lib/icon";
import "ant-design-vue/lib/icon/style/css"; // 加载 CSS
import Vue from "vue";
import common from "./common";
Vue.use(Select).use(Cascader).use(Icon);
const selectMixin = {
  props: {
    field: {},
    fieldValue: "",
    fieldResult: {},
    checkFlag: false,
    fieldStyle: {
      type: String,
      default: "style1",
    },
  },
  data() {
    return {
      fieldNames: {
        label: "optionLabel",
        value: "optionId",
        children: "children",
      },
      fieldObj: {},
      dicResult: [],
      otherOptionIds: [],
      selectIsOpen: false,
      inputFocus: false,
      moved: false,
      optionId: "", //当前选中的option
    };
  },
  watch: {
    checkFlag() {
      //校验
      this.fieldObj.dirty = true;
      //输出结果到父级
      common.updateData(this, this.fieldObj);
    },
  },
  created() {
    if (this.field.fieldLevel == 4) {
      this.field.errorRequired = (
        (window.$sk && window.$sk.$t) ||
        function () {
          return "请选择";
        }
      )("field.please_select");
    }
    if (this.field.listOptionType == "DICT") {
      this.fieldObj = new window.$sk.Cascader(this.field);
      if (this.fieldObj.isCascade === 0) {
        this.fieldObj = new window.$sk.Select(this.field);
      } else {
        cr.each(this.fieldObj.cascaderList, (m) => {
          cr.each(m.children, (i) => {
            if (!i.children.length) {
              i.children = undefined;
            }
          });
        });
      }
    } else {
      this.fieldObj = new window.$sk.Select(this.field);
    }
    this._translateOptions();
    if (this.field.listOptionType == "DICT") {
      this.$watch(
        () => this.fieldObj.listOptions && this.fieldObj.listOptions.length,
        () => this._translateOptions()
      );
    }
    // 不是读写权限禁用
    this.fieldObj.disabled =
      this.field.permissionType && this.field.permissionType != "write";
    cr.each(this.fieldObj.listOptions, (m) => {
      if (m.otherisFillIn == 1) {
        this.otherOptionIds.push(m.optionId);
      }
      if (m.isDefault == 1) {
        this.optionId = m.optionId;
        this.fieldObj.setValue(m.optionId);
      }
    });

    //回填数据
    if (!this.fieldValue) {
      return;
    }
    if (this.fieldObj.isCascade === 1) {
      let currentItem = [];
      cr.each(this.fieldValue, (m, i) => {
        const item = this.fieldObj.listOriginal[i].filter((d) => {
          return d.optionValue === m;
        });
        currentItem = [...currentItem, ...item];
      });
      this.dicResult = currentItem;
      this.fieldObj.setValue(currentItem);
    } else {
      cr.each(this.fieldObj.listOptions, (m) => {
        if (this.fieldValue == m.optionValue) {
          if (this.field.listOptionType == "DICT") {
            this.dicResult = m;
            this.fieldObj.setValue(m.optionId);
          } else {
            this.optionId = m.optionId;
            this.fieldObj.setValue(m.optionId);
          }
        }
      });
    }
  },
  methods: {
    updateDicList(obj) {
      this.dicLists[obj.index] = obj.dictValues;
    },
    dicListChange(value, selectedOptions) {
      this.dicResult = selectedOptions;
      this.fieldObj.setValue(this.dicResult);
      this.moved = false;
      this.$emit("change", {
        displayType: this.fieldObj.displayType,
        value: value[value.length - 1],
        rulesInfo: this.field.rulesInfo,
        rulesCode: this.field.fieldName,
        sortBy: this.field.sortBy,
      });
    },
    inputBlur(e, o) {
      this.fieldObj.setOtherValue(o.optionId, e.target.value);
      this.inputFocus = false;
      this.selectIsOpen = false;
    },
    handleFocus() {
      setTimeout(() => {
        this.selectIsOpen = true;
      }, 100);
      this.moved = true;
    },
    handleBlur() {
      if (!this.inputFocus) {
        this.selectIsOpen = false;
        this.moved = false;
      }
    },
    handleChange(val) {
      this.inputFocus = false;
      this.$refs.selectref.blur();
      this.moved = false;
      this.dicResult = val
        ? [this.fieldObj.listOptions.find((o) => o.optionValue == val)]
        : [];
      if (this.dicResult.length) {
        this.optionId = this.dicResult[0].optionId;
        this.fieldObj.setValue(this.optionId);
      } else {
        this.optionId = "";
        this.fieldObj.setValue(null);
      }
      // Vue.set(this.fieldObj,"value",this.optionId);
      let selectedValue = "";
      //针对客户管理里面的独立选项 fieldLevel 1是全局 2是模块 4 自定义的 3实例下的
      if (
        (this.field.fieldLevel == 1 ||
          this.field.fieldLevel == 2 ||
          this.field.fieldLevel == 3) &&
        this.field.listOptionType == "CUSTOM"
      ) {
        this.fieldObj.listOptions.filter((b) => {
          if (b.checked) {
            selectedValue = b.optionValue;
          }
        });
      }
      this.$emit("change", {
        displayType: this.fieldObj.displayType,
        value: selectedValue ? selectedValue : val,
        rulesInfo: this.field.rulesInfo,
        rulesCode: this.field.fieldName,
        sortBy: this.field.sortBy,
      });
    },
    inputClick(e, o) {
      let index = this.otherOptionIds.findIndex((id) => id == o);
      this.$refs.inputref[index].focus();
      this.inputFocus = true;
      // e.stopPropagation();

      this.fieldObj.setOtherValue(o, e.target.value);
    },
    textChange(e, o) {
      this.fieldObj.setOtherValue(o, e.target.value);
    },
    _translateOptions() {
      var lang = (window.$sk && window.$sk.$lang) || "zh_CN";
      var langKey = lang.toLowerCase();
      if (lang === "zh_CN") return;
      var opts = this.fieldObj && this.fieldObj.listOptions;
      if (!opts) return;
      var fieldOpts = (this.field && this.field.listOptions) || [];
      var dictInfo = (this.field && this.field.dictInfo) || [];
      var changed = false;
      var self = this;
      var findInTree = function (nodes, id, name) {
        for (var j = 0; j < nodes.length; j++) {
          if (nodes[j].paramId == id || nodes[j].name == name) return nodes[j];
          var childKeys = Object.keys(nodes[j].child || {});
          for (var c = 0; c < childKeys.length; c++) {
            var found = findInTree(nodes[j].child[childKeys[c]], id, name);
            if (found) return found;
          }
        }
        return null;
      };
      var translateList = function (list) {
        if (!list) return;
        for (var i = 0; i < list.length; i++) {
          var o = list[i];
          var translated = null;
          if (o.i18n && (o.i18n[lang] || o.i18n[langKey])) {
            translated = o.i18n[lang] || o.i18n[langKey];
          } else if (o[lang] || o[langKey]) {
            translated = o[lang] || o[langKey];
          } else if (fieldOpts.length > 0) {
            var src = fieldOpts.filter(function (f) {
              return f.optionId == o.optionId || f.optionValue == o.optionValue;
            })[0];
            if (src && src.i18n && (src.i18n[lang] || src.i18n[langKey])) {
              translated = src.i18n[lang] || src.i18n[langKey];
            }
          }
          if (!translated && dictInfo.length > 0) {
            var dSrc = findInTree(dictInfo, o.optionId, o.optionValue);
            if (dSrc && dSrc.i18n && (dSrc.i18n[langKey] || dSrc.i18n[lang])) {
              translated = dSrc.i18n[langKey] || dSrc.i18n[lang];
            }
          }
          if (translated) {
            self.$set(o, "optionLabel", translated);
            changed = true;
          }
          var lbl = o.optionLabel || o.optionValue;
          if (o.label !== lbl) {
            self.$set(o, "label", lbl);
            changed = true;
          }
          // 递归翻译子级（级联）
          if (o.children && o.children.length > 0) {
            translateList(o.children);
          }
        }
      };
      translateList(opts);
      // 级联字段：同步翻译 cascaderList（a-cascader 使用的树结构）
      if (this.fieldObj.cascaderList && this.fieldObj.cascaderList !== opts) {
        translateList(this.fieldObj.cascaderList);
      }
      if (changed) {
        this.fieldObj._i18nVersion = (this.fieldObj._i18nVersion || 0) + 1;
      }
    },
  },
};
export default selectMixin;
